import React, { useState } from "react";
import { IconPlus } from "@tabler/icons-react";
import { OrganisationOUT } from "api-client";
import Button from "components/Button";
import MaxBuildingCountAlert from "features/Building/BuildingAlerts/MaxBuildingCountAlert";
import { useTranslation } from "react-i18next";
import { globalStore } from "store/GlobalStore";
import {
  Organisation,
  organisationStore,
} from "features/Organisation/OrganisationStore";
import { isTabletSize } from "utils";
import { observer } from "mobx-react-lite";
import { sidebarMenuStore } from "../SidebarMenuStore";
import BuildingSettings from "features/Building/BuildingSettings";
import { usePostHog } from "@posthog/react";

const AddNewBuilding = ({
  organisation,
}: {
  organisation: OrganisationOUT;
}) => {
  const { t } = useTranslation();
  const [showMaxLimitModal, setShowMaxLimitModal] = useState(false);
  const [sampleBuildingStatus, setSampleBuildingStatus] = useState<
    string | null
  >(null);
  const [openSettings, setOpenSettings] = useState(false);
  const maxBuildingNo = organisation.max_building_entry ?? 0;
  const posthog = usePostHog();

  const handleAddBuilding = (organisation: Organisation) => {
    if (!organisation.can_create_buildings) {
      setShowMaxLimitModal(true);
      return;
    }
    setOpenSettings(true);
    if (isTabletSize()) {
      globalStore.setSidebarOpened(false);
    }
  };

  function onCloseModal() {
    setShowMaxLimitModal(false);
    setSampleBuildingStatus(null);
  }

  const handleAddDemoBuilding = async (organisation: Organisation) => {
    if (!organisation) return;
    setSampleBuildingStatus("in_progress");
    await organisationStore.addDemoBuilding(organisation.id);
    await sidebarMenuStore.getCurrentOrgBuildings();
    setSampleBuildingStatus("done");
    posthog.capture("demo_building_added", {
      organisation_id: organisation.id,
      organisation_name: organisation.name,
    });
  };

  return (
    <>
      <div className="p-4">
        <Button
          leadingIcon={<IconPlus stroke={3} width={15} />}
          type="gray"
          size="small"
          onClick={() => handleAddBuilding(organisation)}
          testID={`addBuilding_${organisation.id}_button`}
        >
          {t("dashboard.addBuilding")}
        </Button>
      </div>
      {openSettings && (
        <BuildingSettings
          open={openSettings}
          close={() => setOpenSettings(false)}
          type="add"
        />
      )}
      <MaxBuildingCountAlert
        open={showMaxLimitModal}
        maxBuildingNo={maxBuildingNo}
        close={onCloseModal}
        sampleBuildingStatus={sampleBuildingStatus}
        onAddSampleBuilding={() => handleAddDemoBuilding(organisation)}
      />
    </>
  );
};

export default observer(AddNewBuilding);
